import createAxiosInstance from './createAxiosInstance'

const mvcPath = process.env.VUE_APP_MVC_URL
const mvcInstance = createAxiosInstance(mvcPath)
const config = {
  metadata: {
    userHandlesErrors: true
  }
}


export const apiMvc = {
  getBottomRightNews: () => mvcInstance.get('/System/GetSystemNotificationList'), // 取得右下角提示窗之資料
  checkAccountPassword: (data) => mvcInstance.post('/Login/CheckAccountPassword', data, config), // 檢查帳號密碼
  getCommunitysWithToken: (data) => mvcInstance.post('/Login/GetCommunitysWithToken', data, config) // 取得社區列表
}
